export const ORGANIZATION_DATA = 'OrganizationData';
export const USER_ORGANIZATION = 'UserOrganization';
/** Default monthly token allowance when contracting AI (request 0308). Editable. */
export const AI_DEFAULT_MONTHLY_TOKENS = 1500;
//# sourceMappingURL=organization.js.map